import React, {useState, useEffect} from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import Web3 from "web3";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import { State, walletActions } from "../store";
import { HeaderWrapper } from "../styles/header";
import metamaskLogo from "../assets/wallets/metamask-logo.webp";
import walletconnectLogo from "../assets/wallets/walletconnect-logo.svg";
import bitkeepLogo from "../assets/wallets/bitkeep.svg";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { walletConnection } = bindActionCreators(walletActions, dispatch);
  const { isConnected, publicKey } = useSelector((state: State) => state.wallet);
  const [visibleMenu, setVisibleMenu] = useState(false);
  const { ethereum } = window as any;
  debugger;
  const web3 = new Web3("ws://localhost:3000");
  debugger;
  const handleMetamaskWallet = async () => {
    if (typeof ethereum === "undefined") {
      return toast.error("Please install MetaMask to use this service!", { position: toast.POSITION.TOP_RIGHT });
    }
    try {
      await ethereum.enable();
      web3.setProvider(ethereum);
      await ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0xA86A' }], // mainnet:0xA86A , testnet: 0xA869  chainId must be in hexadecimal numbers
      });
      web3.eth.getAccounts().then(accounts => {
        walletConnection(ethereum.isConnected(), accounts[0], ethereum.chainId, "metamask");
      });
      setVisibleMenu(true);
      
    } catch (err) {
      return toast.error(`${err}`, { position: toast.POSITION.TOP_RIGHT });
    }
  }

  const handleBitkeepWallet = async () => {
    if (typeof ethereum === "undefined") {
      return toast.error("Please install MetaMask to use this service!", { position: toast.POSITION.TOP_RIGHT });
    }
    try {
      
      if(ethereum.isBitKeep) {
        await ethereum.enable();
        web3.setProvider(ethereum);
        await ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0xA86A' }], // mainnet:0xA86A , testnet: 0xA869  chainId must be in hexadecimal numbers
        });
        web3.eth.getAccounts().then(accounts => {
          walletConnection(ethereum.isConnected(), accounts[0], ethereum.chainId, "metamask");
        });
        setVisibleMenu(true);
      } else {
        alert("Please Install BitKeep Extension!");
      }

      
    } catch (err) {
      return toast.error(`${err}`, { position: toast.POSITION.TOP_RIGHT });
    }
  }

  const handleConnectWallet = async () => {
    const connector = new WalletConnect({
      bridge: "https://bridge.walletconnect.org", // Required
      qrcodeModal: QRCodeModal,
    });

    if (!connector.connected) {
      // create new session
      connector.createSession();
    }
    // Subscribe to connection events
    connector.on("connect", (error: any, payload: any) => {
      if (error) {
        console.log(error);
      }
      // Get provided accounts and chainId
      const { accounts, chainId } = payload.params[0];
      walletConnection(ethereum.isConnected(), accounts[0], ethereum.chainId, "walletconnect");

      console.log(accounts);
      setVisibleMenu(true);
      
    });
  }

  const handleDisconnectToWallet = () => {
    console.log("Disconnecting MetaMask...");
    setVisibleMenu(false);
    walletConnection(false, "", ethereum.chainId, "");
  }

  useEffect(() => {
    handleMetamaskWallet();
  }, []);
  return (
    <HeaderWrapper>
      <img id="bannerlogo" src="https://heroeschained.com/assets/images/banner-hereos.svg" alt="logo" onClick={() => navigate("/")} style={{ cursor: "pointer"}} />

      {/* <div className="nav-item" onClick={() => navigate("/")} style={{textAlign:'center'}}>
        <img src="logos/homelogo.png" style={{width:'35px', height:'35px'}} alt="nav-img" />
        <h6>Home</h6>
      </div> */}
      <div className="nav-item" onClick={() => navigate('/shop')} style={{textAlign:'center'}}>
        <img src="../logos/marketplacelogo.png" style={{width:'35px', height:'35px'}}  alt="nav-img" />
        <h6>Market</h6>
      </div>
      <div className="nav-item" onClick={() => window.location.href = 'https://staking02.heroeschained.com/'} style={{textAlign:'center'}}>
        <img src="../logos/stakinglogo.png" style={{width:'35px', height:'35px'}}  alt="nav-img" />
        <h6>Staking</h6>
      </div>
      <div className="nav-item" onClick={() => window.location.href = "https://fov.heroeschained.com/"} style={{textAlign:'center'}}>
        <img src="../logos/gamelogo.png" style={{width:'35px', height:'35px'}}  alt="nav-img" />
        <h6>Game</h6>
      </div>
      <div className="nav-item" onClick={() => navigate("/wallet")} style={{textAlign:'center'}}>
        <span id="walletmenu" style={{display: visibleMenu ? 'block' : 'none'}}><img src="../logos/wallet.png" style={{width:'35px', height:'35px'}}  alt="nav-img" />
        <h6>Wallet</h6></span>
      </div>

      {/* <div className="searchbar">
        <input type={"search"} placeholder="Search..." />
        <i className="fa fa-search"></i>
      </div> */}
      <div className="connect-wallet">
        {isConnected ?
          <>
            <button onClick={() => handleDisconnectToWallet()} style={{ backgroundColor: "#f5a31f" }}>DISCONNECT</button>
            <span>{publicKey?.slice(0, 10)}...{publicKey?.slice(-4)}</span>
          </>
          :
          // <button onClick={() => setSelectWallet(true)} style={{ backgroundColor: "#00a3f2" }}>CONNECT</button>
          <DropdownButton
            menuVariant="dark"
            title="Connect Wallet"
          >
            <Dropdown.Item onClick={() => handleMetamaskWallet()}>
              <img src={metamaskLogo} alt="metamask-logo" />
              Metamask
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => handleConnectWallet()}>
              <img src={walletconnectLogo} alt="connect-wallet logo" />
              Wallet Connect
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => handleBitkeepWallet()}>
              <img src={bitkeepLogo} alt="bitkeep-logo" />
              BitKeep
            </Dropdown.Item>
          </DropdownButton>
        }
      </div>
    </HeaderWrapper>
  )
}

export default Header;
